/*
 *  main.js
 *
 *  Here you can include all js files
 *
 */

// import scripts

import $ from 'jquery';
import { scrollToSection } from './scroll-to-section';
import { slider } from './slider';
//import { carBrowser } from './car-browser';

const App = {

	// start app

	ready: function() {
		scrollToSection();
		slider();
		//carBrowser();
	},

	load: function() {

	}
};

$(document).ready(App.ready);

$(window).on('load', App.load);